import React from 'react';
import { Box, Typography, Container, Card, CardContent, Button } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import NavBar from '../../Components/NavBar/navbar';
import FooterSection from '../../Components/Footer/footer';
import { DEVELOPERS } from '../../utils/docsData';
import { THEME, pageBackgroundSx, gridOverlaySx } from '../../theme';

export default function ContactPage() {
    return (
        <Box sx={pageBackgroundSx}>
            <Box sx={gridOverlaySx} />
            <NavBar />
            <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, pt: 12, pb: 8 }}>
                <Typography variant="overline" sx={{ color: THEME.primary, fontWeight: 'bold', letterSpacing: 2 }}>
                    Contact
                </Typography>
                <Typography variant="h3" fontWeight={800} color={THEME.textMain} sx={{ mb: 2 }}>
                    Get in touch
                </Typography>
                <Typography variant="body1" color={THEME.secondary} sx={{ mb: 4, lineHeight: 1.8 }}>
                    Questions about EvolveX? Email the team.
                </Typography>

                {DEVELOPERS.map((dev) => (
                    <Card
                        key={dev.email}
                        sx={{
                            bgcolor: THEME.cardBg,
                            border: `1px solid ${THEME.border}`,
                            borderRadius: '12px',
                            mb: 2,
                        }}
                    >
                        <CardContent sx={{ p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                            <Box>
                                <Typography variant="h6" color={THEME.textMain} fontWeight={700}>
                                    {dev.name}
                                </Typography>
                                <Typography variant="body2" color={THEME.secondary}>
                                    {dev.role}
                                </Typography>
                                <Typography variant="body2" color={THEME.primary} sx={{ mt: 1 }}>
                                    {dev.email}
                                </Typography>
                            </Box>
                            <Button
                                variant="outlined"
                                startIcon={<EmailIcon />}
                                href={`mailto:${dev.email}`}
                                sx={{ borderColor: THEME.primary, color: THEME.primary }}
                            >
                                Email
                            </Button>
                        </CardContent>
                    </Card>
                ))}
            </Container>
            <FooterSection />
        </Box>
    );
}
